































import Vue from 'vue';
import layout from '@/libs/layout/components/history'
import { Component, Prop } from 'vue-property-decorator';
import { TUploadHistoryPage, TLayout } from '@/types/utils';
@Component({})
export default class History extends Vue {
  @Prop({
    type: Object,
    default() {
        return {}
    }
  })
  page!: TUploadHistoryPage;
  private dialogVisible = false;
  private layout: TLayout = layout
  private handleClose() {
    this.dialogVisible = false;
  }
}
